import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { addQueueGlobalCount, resetQueueGlobalCount } from '../../../store/emarsys/action';
import { store } from '../../../store';

export default function eventClickHomepage(
  title: string,
  sectionName: string,
  buttonName: string,
  impressionData?: {
    homepageBannerName?: string;
    carModel?: string;
    itemName?: string;
    skuPrice?: string;
    promoName?: string;
    branchName?: string;
    beritaTipsName?: string;
  }
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isHomepageActive = getFlagValue(FLAG_ENUM.EMARSYS_HOME_PAGE);
  if (!isFlagActive || !isHomepageActive) return;
  const state = store.getState();
  const { userData } = state.auth || {
    userData: null,
  };
  if (userData?.customerNo) {
    ScarabQueue.push(['setCustomerId', userData?.customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: 'homepage',
    page_title: title,
    page_url: window.location.href,
    section_name: sectionName,
    button_name: buttonName,
  };

  if (impressionData?.homepageBannerName) {
    valueClickAction.homepage_banner_name = impressionData.homepageBannerName;
  }

  if (impressionData?.carModel) {
    valueClickAction.car_model = impressionData.carModel;
  }

  if (impressionData?.itemName) {
    valueClickAction.item_name = impressionData.itemName;
  }

  if (impressionData?.skuPrice) {
    valueClickAction.sku_price = impressionData.skuPrice;
  }

  if (impressionData?.promoName) {
    valueClickAction.promo_name = impressionData.promoName;
  }

  if (impressionData?.branchName) {
    valueClickAction.branch_name = impressionData.branchName;
  }

  if (impressionData?.beritaTipsName) {
    valueClickAction.berita_tips_name = impressionData.beritaTipsName;
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);

  if (
    buttonName !== 'lihat semua' &&
    buttonName !== 'minta penawaran' &&
    buttonName !== 'pilih lokasi'
  ) {
    ScarabQueue.push(['go']);
    store.dispatch(resetQueueGlobalCount());
  } else {
    store.dispatch(addQueueGlobalCount());
  }
}
